import React, { Fragment } from 'react';

export default {
  startDate: new Date(1998, 0, 0),
  endDate: new Date(1998, 9, 25),
  hideItem: true,
  description: '',
  description_long: '',
  items: [
    {
      milestone: true,
      coords: {
        x: new Date(1998, 0, 1),
        y: 38
      },
      coordsMobile: {
        x: new Date(1998, 0, 1),
        y: 37
      },
      kicker: 'seit 1995',
      title: (
        <h3>
          Oskar Lafontaine <em>(1212 Tage)</em>
        </h3>
      ),
      text: (
        <p>
          <span className="media">
            <img src="images/chronik/01-1998-lafontaine.jpg" />
            <span className="media-sub clearfix">
              <span className="media-caption"> </span>
              <span className="media-credit">dpa/picture alliance</span>
            </span>
          </span>
        Der Saarländer ist der siebte Vorsitzende der Nachkriegszeit. 
        Er hatte sich im November 1995 in einer Kampfabstimmung gegen den damaligen SPD-Chef Rudolf Scharping durchgesetzt. 
        Die lange heillos zerstrittene SPD wirkt Anfang 1998 geschlossen, und Lafontaine schwört die Genossen auf die Regierungsübernahme ein. 
        Doch Kanzlerkandidat wird im März sein Widersacher: Gerhard Schröder.
        </p>
      ),
      additional: (
        <ul>
          <li>
            <strong>Umfragehoch: </strong>46&nbsp;Prozent (Infratest dimap) am
            4. April 1998
          </li>
          <li>
            <strong>Umfragetief: </strong>37&nbsp;Prozent (Forsa) am 25. Februar
            1999
          </li>
        </ul>
      )
    },
    {
      milestone: false,
      coords: {
        x: new Date(1998, 8, 26),
        y: 43.5
      },
      coordsMobile: {
        x: new Date(1998, 8, 26),
        y: 44
      },
      kicker: '27. September 1998',
      title: 'SPD triumphiert bei der Bundestagswahl',
      text: (
        <p>
          Nach 16 Jahren im Amt wird Helmut Kohl (CDU) abgewählt. Mit 40,9
          Prozent wird die SPD mit ihrem Kanzlerkandidaten Gerhard Schröder
          stärkste Kraft. Damit löst erstmals in der Geschichte der
          Bundesrepublik eine Oppositionspartei die Regierung direkt nach Wahlen
          ab.
        </p>
      )
    }
  ]
};
